// extracted by mini-css-extract-plugin
export var boxSection = "style-module--box-section--7752f";
export var boxSection__box = "style-module--box-section__box--8923f";
export var boxSection__boxes = "style-module--box-section__boxes--83de9";
export var boxSection__icon = "style-module--box-section__icon--2793a";
export var boxSection__text = "style-module--box-section__text--2e68e";